import React from 'react';
import { FormTitleType } from '../ricFormTypes';

function SchemaFormTitle({ formElement }: { formElement: FormTitleType }) {
  const { title } = formElement;

  return <div className="form-title">{title}</div>;
}

export default SchemaFormTitle;
